module.exports = __webpack_public_path__ + "img/4.e5b04bd.jpg";